import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';
import { getLoadingEffects } from 'src/shared/selectors/sharedSelectors';

const getAuthenticationState = (state: RootState) => state.authentication;

export const isAuthenticated = createSelector(getAuthenticationState, auth => auth.isAuthenticated);

export const getJustSignedOut = createSelector(getAuthenticationState, auth => auth.justSignedOut);

export const getAuthenticationErrorMessage = createSelector(
    getAuthenticationState,
    ({ errorMessage }) => errorMessage,
);

export const isLoginInProgress = createSelector(
    getLoadingEffects,
    ({ authentication }) => !!authentication.login,
);

export const isAuthenticating = createSelector(
    getAuthenticationState,
    auth => auth.isAuthenticating,
);

export const shouldValidateAuthData = createSelector(
    getAuthenticationState,
    auth => auth.shouldValidateAuthData,
);
